import { type QueryClient } from '@tanstack/react-query';

import { FetchGetOffersByPinLoadService } from '@/packages/query-state/shared/store/search-offers/v1/get-offers-by-pin/load';
import { FetchSearchOffersDesktopLoadService } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/load';
import { type TViewMode } from '@/packages/redux-state/store/slices/listingLayout/slice';

import { type IPageByPinSchema } from '@/repositories/generated/shared/search-offers/entities/listing_analytics/PageByPinSchema';
import { type IPageSchema } from '@/repositories/generated/shared/search-offers/entities/listing_analytics/PageSchema';

type Page = IPageSchema | IPageByPinSchema;

interface IGetAnalyticsPageParams {
  queryClient: QueryClient;
  activePinId?: string;
  viewMode: TViewMode;
  searchOffersQueryKey: string[];
}

export type AnalyticsPage = Partial<Page> & {
  listingType: 'map' | 'list';
  pageType: 'ListingHybrid';
  siteType: 'desktop';
};

export function getAnalyticsPage(params: IGetAnalyticsPageParams): AnalyticsPage {
  const { activePinId, viewMode, searchOffersQueryKey, queryClient } = params;

  if (activePinId) {
    return {
      ...getOffersByPinPage(queryClient, activePinId),
      listingType: 'map',
      pageType: 'ListingHybrid',
      siteType: 'desktop',
    };
  }

  return {
    ...getOffersPage(queryClient, searchOffersQueryKey),
    listingType: viewMode === 'map' ? 'map' : 'list',
    pageType: 'ListingHybrid',
    siteType: 'desktop',
  };
}

function getOffersByPinPage(queryClient: QueryClient, activePinId: string): IPageByPinSchema {
  const offersByPinData = new FetchGetOffersByPinLoadService(queryClient).getQueryData(activePinId);

  return offersByPinData?.analytics.page as IPageByPinSchema;
}

function getOffersPage(queryClient: QueryClient, queryKey: string[]): IPageSchema {
  const data = new FetchSearchOffersDesktopLoadService(queryClient, queryKey).getQueryData();

  return data?.pages[data.pages.length - 1].analytics.page as IPageSchema;
}
